import { createApp } from 'vue'
import CalculatorForm from "~/src/components/premium/CalculatorForm.vue";

export const PremiumShowView = {

  init() {
    // Inits Premium calculator.
    createApp(CalculatorForm, { action: 'create' })
      .mount('#form-calculator-premium')
  },

}
